// require('newrelic');
// Keep this import first. When embedded in a ConnectAmericas page it starts reporting our
// content height so the parent can size its iframe to us; imports are evaluated in order, so
// listing it above './App' means the bridge is live before any app module runs. No-op when
// this page is opened directly.
import './utils/iframeResizeBridge';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
